import script from "./AppDemos.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDemos.vue?vue&type=script&setup=true&lang=js"

import "./AppDemos.vue?vue&type=style&index=0&id=18603548&style=text%2Fcss&lang=css"

const __exports__ = script;

export default __exports__